export * from 'roles/selectors/roles_selectors';



// WEBPACK FOOTER //
// src/modules/secured/modules/roles/selectors/index.js